import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchAnalytics = createAsyncThunk('analytics/fetch', async (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.startDate && params.endDate) {
    queryParams.append('startDate', params.startDate);
    queryParams.append('endDate', params.endDate);
  } else if (params.period) {
    queryParams.append('period', params.period);
  }

  // Add location filter if specified
  if (params.locationId) {
    queryParams.append('locationId', params.locationId);
  }

  const url = queryParams.toString() ? `/analytics/overview?${queryParams.toString()}` : '/analytics/overview';
  const res = await axios.get(url);
  console.log('[Analytics Slice] Full API response:', res.data);
  console.log('[Analytics Slice] Analytics data received:', {
    totalRevenue: res.data.data?.totalRevenue,
    onlineSales: res.data.data?.onlineSales,
    offlineSales: res.data.data?.offlineSales,
    totalCOGS: res.data.data?.totalCOGS,
    totalOperatingExpenses: res.data.data?.totalOperatingExpenses,
    grossProfit: res.data.data?.grossProfit,
    netProfit: res.data.data?.netProfit,
    profitMargin: res.data.data?.profitMargin,
    totalShippingSpend: res.data.data?.totalShippingSpend,
    totalDiscountGiven: res.data.data?.totalDiscountGiven,
    averageOrderValue: res.data.data?.averageOrderValue,
    customerLifetimeValue: res.data.data?.customerLifetimeValue,
    totalVisits: res.data.data?.totalVisits,
    checkoutAbandonmentRate: res.data.data?.checkoutAbandonmentRate,
    pendingSettlement: res.data.data?.pendingSettlement,
    settledAmount: res.data.data?.settledAmount,
    refundedAmount: res.data.data?.refundedAmount,
    refundedCount: res.data.data?.refundedCount,
    totalCarts: res.data.data?.totalCarts,
    funnelData: res.data.data?.funnelData,
    banners: res.data.data?.banners
  });
  return res.data.data; // Extract the actual data from the API response
});

export const refreshAnalytics = createAsyncThunk('analytics/refresh', async (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.startDate && params.endDate) {
    queryParams.append('startDate', params.startDate);
    queryParams.append('endDate', params.endDate);
  } else if (params.period) {
    queryParams.append('period', params.period);
  }

  // Add location filter if specified
  if (params.locationId) {
    queryParams.append('locationId', params.locationId);
  }

  const url = queryParams.toString() ? `/analytics/overview?${queryParams.toString()}` : '/analytics/overview';
  const res = await axios.get(url);
  return res.data.data; // Extract the actual data from the API response
});

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: { data: null, status: 'idle', error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchAnalytics.pending, (s) => { s.status = 'loading'; })
     .addCase(fetchAnalytics.fulfilled, (s, a) => { s.status = 'succeeded'; s.data = a.payload; })
     .addCase(fetchAnalytics.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; })
     .addCase(refreshAnalytics.pending, (s) => { s.status = 'refreshing'; })
     .addCase(refreshAnalytics.fulfilled, (s, a) => { s.status = 'succeeded'; s.data = a.payload; })
     .addCase(refreshAnalytics.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; });
  }
});

export default analyticsSlice.reducer;
